module.exports = __webpack_public_path__ + "static/img/bg-4-3.8cd148c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bg-4-3.jpg
// module id = Zot6
// module chunks = 7